module.exports = __webpack_public_path__ + "img/叶坪红军检阅台.0c86cd98.png";